import { render } from "./SubmissionList.vue?vue&type=template&id=0f5f4bfa"
import script from "./SubmissionList.vue?vue&type=script&lang=ts"
export * from "./SubmissionList.vue?vue&type=script&lang=ts"
script.render = render

export default script